"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop = _interopRequireDefault(require("lodash/noop"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Icon = _interopRequireDefault(require("../../Icon/Icon.index"));

var _Gallery = require("../Gallery.types");

var _Tabs = require("./Tabs.styles");

var Tabs = function Tabs(_ref) {
  var options = _ref.options,
      _onChange = _ref.onChange,
      selected = _ref.selected,
      theme = _ref.theme,
      name = _ref.name;
  return /*#__PURE__*/_react["default"].createElement(_Tabs.TabContainer, null, options.map(function (_ref2) {
    var _theme$gallery, _theme$gallery$tabs, _theme$gallery$tabs$c, _theme$gallery$tabs2;

    var label = _ref2.label,
        value = _ref2.value;
    var itemName = "".concat(name, "-").concat(label.toLowerCase());
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: itemName
    }, /*#__PURE__*/_react["default"].createElement(_Tabs.TabInput, {
      id: itemName,
      checked: selected === value,
      type: "radio",
      onChange: function onChange() {
        return _onChange(value);
      }
    }), /*#__PURE__*/_react["default"].createElement(_Tabs.TabLabel, {
      htmlFor: itemName,
      active: selected === value
    }, (theme === null || theme === void 0 ? void 0 : (_theme$gallery = theme.gallery) === null || _theme$gallery === void 0 ? void 0 : (_theme$gallery$tabs = _theme$gallery.tabs) === null || _theme$gallery$tabs === void 0 ? void 0 : _theme$gallery$tabs.icons) && theme.gallery.tabs.icons[value] && /*#__PURE__*/_react["default"].createElement(_Tabs.TabIcon, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: theme.gallery.tabs.icons[value],
      color: (_theme$gallery$tabs$c = (_theme$gallery$tabs2 = theme.gallery.tabs) === null || _theme$gallery$tabs2 === void 0 ? void 0 : _theme$gallery$tabs2.color) !== null && _theme$gallery$tabs$c !== void 0 ? _theme$gallery$tabs$c : '#fff',
      size: "auto"
    })), label));
  }));
};

Tabs.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  })),
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  selected: _propTypes["default"].string,
  theme: _Gallery.galleryTheme
};
Tabs.defaultProps = {
  options: [],
  name: 'gcc-product-gallery-type',
  onChange: _noop["default"],
  selected: undefined,
  theme: undefined
};
Tabs.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tabs",
  "props": {
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "label": {
              "name": "string",
              "required": false
            },
            "value": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "name": {
      "defaultValue": {
        "value": "'gcc-product-gallery-type'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "selected": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "galleryTheme"
      },
      "required": false
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Tabs);

exports["default"] = _default;